import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords don't match"); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — sign in with your new password");
      navigate("/login");
    } catch (err) { setError(apiError(err.response?.data?.detail) || "Could not reset password"); }
    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20">
      <div className="bg-[#12141a] border border-zinc-800 rounded-2xl p-8" data-testid="reset-card">
        <h1 className="font-display text-3xl font-extrabold text-white">Choose a new password</h1>
        {!token ? (
          <p className="text-red-400 text-sm mt-3" data-testid="reset-no-token">This link is missing its token. <Link to="/forgot-password" className="text-[#ff6a13] hover:underline">Request a new one</Link>.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div>
              <Label className="text-zinc-300">New password</Label>
              <PasswordInput testid="reset-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" placeholder="At least 8 characters" />
            </div>
            <div>
              <Label className="text-zinc-300">Confirm password</Label>
              <PasswordInput testid="reset-confirm" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 bg-[#1e222d] border-zinc-700 text-white focus:border-[#ff6a13] focus:ring-[#ff6a13]" placeholder="••••••••" />
            </div>
            {error && <p className="text-red-400 text-sm" data-testid="reset-error">{error}</p>}
            <Button data-testid="reset-submit" disabled={loading} type="submit" className="w-full bg-[#ff6a13] hover:bg-[#ff8a3d] text-white rounded-full h-11 font-semibold">{loading ? "Saving…" : "Set new password"}</Button>
          </form>
        )}
        <p className="text-sm text-zinc-500 mt-6 text-center"><Link to="/login" className="text-[#ff6a13] hover:underline">Back to sign in</Link></p>
      </div>
    </div>
  );
}
